import graphqlClient from '@/graphql/graphql-client';
import { eqFromWhere, organizationIdForQuery, toListQueryVariables } from '@/graphql/list-query';
import type { ListQueryVariables } from '@/graphql/types';
import { useQuery } from '@tanstack/react-query';
import {
  OrgCompanysByUserDocument,
  OrgCompanysDocument,
  type OrgCompanysQuery,
  type OrgCompanysQueryVariables,
} from '@/graphql/generated/graphql';

export type CompanyItem = NonNullable<
  NonNullable<OrgCompanysQuery['getOrgCompanys']>['items'][number]
>;

export type GetCompaniesResponse = OrgCompanysQuery;

export const useGetCompanies = (
  params?: ListQueryVariables<Record<string, unknown>>,
  options?: { enabled?: boolean }
) => {
  const { where, paging } = toListQueryVariables(params);
  const createdBy = eqFromWhere(where, 'CreatedBy');
  const variables: OrgCompanysQueryVariables = {
    organizationId: organizationIdForQuery(where),
    pageNo: paging.pageNo,
    pageSize: paging.pageSize,
  };

  return useQuery({
    queryKey: ['companies', createdBy ? { createdBy, ...paging } : variables],
    queryFn: () =>
      createdBy
        ? graphqlClient.request(OrgCompanysByUserDocument, {
            createdBy,
            pageNo: paging.pageNo,
            pageSize: paging.pageSize,
          })
        : graphqlClient.request(OrgCompanysDocument, variables),
    enabled: options?.enabled ?? true,
  });
};

const PAGE = { pageNo: 1, pageSize: 200 };

export const requestOrgCompanies = (organizationId: string) =>
  graphqlClient.request(OrgCompanysDocument, { organizationId, ...PAGE });

export const requestOrgCompaniesByUser = (createdBy: string) =>
  graphqlClient.request(OrgCompanysByUserDocument, { createdBy, ...PAGE });

export const GET_COMPANIES_QUERY = OrgCompanysDocument;
